import { sha256 } from 'crypto-hash';
import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import AppDialog from '../components/AppDialog';

const queryLink = createPersistedQueryLink({
  disable: () => false,
  sha256,
});

const httpLink = createHttpLink({
  credentials: 'include',
  uri: process.env[`REACT_APP_API_ENDPOINT`],
});

const errorLink = onError(({ networkError }) => {
  if (networkError?.result?.code === 'ERR_INVALID_QUERY') {
    document.dispatchEvent(
      new CustomEvent(AppDialog.events.open, {
        detail: {
          key: 'invalidQuery',
        },
      }),
    );
  }
});

export default function getApolloClient() {
  return new ApolloClient({
    cache: new InMemoryCache({
      typePolicies: {
        Product: {
          keyFields: ['name'],
        },
      },
    }),
    link: from([errorLink, queryLink, httpLink]),
  });
}
